<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord" />
    </div>
</template>

<script>
import axios from '@/axios'
import EventBus from '@/EventBus'

export default {
  name: 'CellRendererActions',
  methods: {
    editRecord () {
      this.$router.push("/users/view/"+ this.params.data.user.id)
    },
    async confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${this.params.data.user.full_name}"`,
        accept: await this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    async deleteRecord () {
      try {
        const token = localStorage.usertoken;        
        const headers = { 'Authorization': token };
        await axios.delete(`/approver/${this.params.data.id}`, { headers });
        this.showCreateDialog = false
        this.showDeleteSuccess()
        // this.$router.go(0);
        EventBus.$emit('load-approver')
      } catch ({ response }) {
        this.$vs.notify({
          color: 'danger',
          title: 'User Deleted',
          text: response.data.errors
        }) 
      }
      
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  }
}
</script>
